<section class="gallery section" id="gallery">
  <div class="shell-container">
    <div class="gallery__header reveal" appRevealOnScroll="80ms">
      <div class="badge">{{ content.badge }}</div>
      <h2>{{ content.heading }}</h2>
      <p class="gallery__lede">{{ content.lede }}</p>
    </div>

    <div class="gallery__grid">
      <figure
        class="gallery__item reveal"
        *ngFor="let item of content.items | slice:0:6"
        [ngClass]="'gallery__item--' + item.layout"
        [appRevealOnScroll]="item.delay"
      >
        <img
          [src]="item.src"
          [alt]="item.alt"
          loading="lazy"
          decoding="async"
        />
      </figure>
    </div>
  </div>
</section>
